/* see country code to country name mapping at
   node_modules/react-phone-number-input/locale/en.json */

export const countriesOrder = ['BE', 'NL', 'FR']
